<template>
  <template v-if="this.showOverall">
    <template v-if="this.showAvatar">
      <div class="cw-avatar-icon" v-bind:style="{ 'background-image': 'url(' + this.downloadUrl + ')' }">

      </div>
    </template>
    <template v-else>
      <div class="cw-avatar-icon">
        {{ this.initials }}
      </div>
    </template>
  </template>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { calcInitials } from '@/helpers/stringHelper';
import { SenderInfoData } from '@/TickApi';

@Component
export default class TickAvatar extends Vue {
  @Prop({ default: {} }) private sender!: SenderInfoData;

  private get showOverall(): boolean {
    return this.sender?.name != null;
  }
  private get initials() {
    return (this.sender && this.sender.name)
      ? calcInitials(this.sender.name)
      : "me";
  }
  private get showAvatar() {
    return this.sender && this.sender.avatarUrl && this.sender.avatarUrl.length;
  }

  private get downloadUrl() {
    return this.sender.avatarUrl;
  }


}
</script>

<style lang="scss" scoped>
@import "@/styles/theme";

.cw-avatar-icon {
  grid-area: icon;
  width: 40px;
  height: 40px;
  border-radius: 9999px;
  border: 1px solid $brand;
  background-color: $brand100;
  color: $brand;
  display: grid;
  place-content: center;
  @include font-poppins;
  font-weight: 500;
  font-size: 100%;
  line-height: 24px;
  overflow: hidden;

  background-repeat: no-repeat;
  background-size: cover;

}


/* For Mobile */
@media screen and (hover: none) and (orientation:portrait),
screen and (max-width: 800px) {

  .cw-avatar-icon {
    width: 10vw;
    height: 10vw;
  }
}
</style>
